var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "div",
        {
          staticClass: "tile is-parent",
          class: { "box ml-2 mb-5": _vm.showBox },
        },
        [
          _c("article", { staticClass: "tile is-child is-parent" }, [
            _vm._m(0),
            _c("div", { staticClass: "is-divider" }),
            _c("div", { staticClass: "tile is-ancestor" }, [
              _c("div", { staticClass: "tile" }, [
                _c("div", { staticClass: "tile is-parent is-half" }, [
                  _c(
                    "article",
                    {
                      staticClass: "tile is-child",
                      class: { disabled: _vm.value.quoteId },
                    },
                    [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("E-Com Type"),
                        ]),
                        _c("div", { staticClass: "control select" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.innerEcomType,
                                  expression: "innerEcomType",
                                },
                              ],
                              staticClass: "select-width",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.innerEcomType = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { value: "all" },
                                  domProps: {
                                    selected: _vm.innerEcomType == "all",
                                  },
                                },
                                [_vm._v("ALL")]
                              ),
                              _c(
                                "option",
                                { domProps: { value: _vm.ecomTypeEnum.ORM } },
                                [_vm._v("ORM")]
                              ),
                              _c(
                                "option",
                                { domProps: { value: _vm.ecomTypeEnum.PNET } },
                                [_vm._v("PNET")]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c(
                          "label",
                          { staticClass: "label is-required-label" },
                          [_vm._v("Insurer")]
                        ),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _vm.insurers
                              ? _c(
                                  "multiselect",
                                  {
                                    class: [
                                      _vm.$v.entity.insurerId.$error
                                        ? "is-danger"
                                        : "",
                                    ],
                                    attrs: {
                                      label: "name",
                                      placeholder: "Search By Name...",
                                      options: _vm.insurers,
                                      loading: _vm.isInsurerLoading,
                                      searchable: true,
                                      "show-labels": false,
                                      "allow-empty": true,
                                    },
                                    on: {
                                      select: _vm.selectInsurer,
                                      remove: _vm.removeInsurer,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "option",
                                          fn: function (props) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(props.option.name)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2446573312
                                    ),
                                    model: {
                                      value: _vm.selectedInsurer,
                                      callback: function ($$v) {
                                        _vm.selectedInsurer = $$v
                                      },
                                      expression: "selectedInsurer",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "has-text-danger",
                                        attrs: { slot: "noResult" },
                                        slot: "noResult",
                                      },
                                      [_vm._v("Insurer not found.")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.$v.entity && !_vm.$v.entity.insurerId.required
                              ? _c("span", { staticClass: "help is-danger" }, [
                                  _vm._v("Insurer is required"),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Claim No."),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value.claimNo,
                                expression: "value.claimNo",
                              },
                            ],
                            staticClass: "input",
                            class: {
                              "is-danger": _vm.$v.entity.claimNo.$error,
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.value.claimNo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value,
                                  "claimNo",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Excess"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c(
                            "div",
                            { staticClass: "control" },
                            [
                              _c("vue-numeric", {
                                staticClass: "input has-text-right",
                                attrs: {
                                  min: 0,
                                  formats: "",
                                  precision: 2,
                                  symbol: _vm.$company.currency.symbol,
                                },
                                model: {
                                  value: _vm.value.excess,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.value, "excess", $$v)
                                  },
                                  expression: "value.excess",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Is Third Party?"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c(
                            "div",
                            { staticClass: "control" },
                            [
                              _c("bulma-checkbox", {
                                model: {
                                  value: _vm.value.isThirdParty,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.value, "isThirdParty", $$v)
                                  },
                                  expression: "value.isThirdParty",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns mb-0" }, [
      _c("div", { staticClass: "column is-flex is-align-items-center" }, [
        _c("i", { staticClass: "icon mdi mdi-shield-outline mdi-24px" }),
        _c("p", { staticClass: "modal-card-title pl-1" }, [_vm._v("Insurer")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }